import {Advertisement} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/advertisement.types';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions} from '@aboutyou/tracking';
import {
  Image,
  UnstyledLink,
  useGetAriaLabelFromUrl,
} from '@aboutyou/ui-components';
import React from 'react';

interface NavigationAdvertisementProps {
  isVisible: boolean;
  advertisement: Advertisement;
}

export const NavigationAdvertisement: React.FC<
  NavigationAdvertisementProps
> = ({isVisible, advertisement}) => {
  const {promotionTracking} = advertisement;

  const advertisementImage = (
    <NavigationAdvertisementImage advertisement={advertisement} />
  );

  return isVisible ? (
    <TrackPromotions
      promotion={{
        source: TrackingPromotionCreative.BasFlyoutTeaser,
        advertisement: {
          id: promotionTracking?.id ?? '',
          name: promotionTracking?.name ?? '',
          path: advertisement.targetUrl?.url ?? '',
        },
      }}
      streamPosition={0}
      triggerOnce
    >
      {advertisementImage}
    </TrackPromotions>
  ) : (
    advertisementImage
  );
};

const NavigationAdvertisementImage: React.FC<{
  advertisement: Advertisement;
}> = ({advertisement}) => {
  const getAriaLabelFromUrl = useGetAriaLabelFromUrl();

  return (
    <UnstyledLink
      data-testid="navigationAdvertisement"
      to={advertisement.targetUrl!.url}
      aria-label={getAriaLabelFromUrl(advertisement.targetUrl!.url)}
    >
      <Image
        alt={advertisement.image.description}
        src={advertisement.image.url}
        breakpoints={[]}
        ratio="1:1"
        disableFixedRatio
      />
    </UnstyledLink>
  );
};
